module.exports = __webpack_public_path__ + "img/preview.2b0b76dc.jpg";